import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';

@Injectable({ providedIn: 'root' })
export class NotifyService {
  constructor(private http: HttpClient) {}

  notify(email: string): Observable<void> {
    return this.http.post<void>(`${environment.backendUrl}/notify`, { email });
  }
}
